module.exports = __webpack_public_path__ + "img/dNum.110cf469.svg";